import React from "react"
import { withStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import defaultTheme from "../theme"

const ColorButton = withStyles((theme) => ({
  root: {
    borderColor: defaultTheme.palette.success.main,
    color: defaultTheme.palette.success.dark,
  },
}))(Button)

export default function ButtonSave({ children, noSubmit = false, ...props }) {

  return (
    <ColorButton
      variant="outlined"
      type={noSubmit ? "button" : "submit"}
      {...props}
    >
      {children}
    </ColorButton>
  )
}
